import {
  Action,
  OpenSearchResponse,
  Order,
  OrderResponse,
  OrderSearchRequest,
  OrderSignatureRequest,
  OrderVisitFrequency,
} from "models/order-management/models";

const baseVFOrder: OrderVisitFrequency = {
  externalPatientChartId: 41663,
  patientName: "JustAdmit, Carey M. Jr.",
  tenantId: 697190,
  orderType: "VISIT_FREQUENCY",
  nameDescription: "",
  createdAction: {
    actionType: "CREATED",
    userId: 744405,
    username: "auto@mation.com",
    displayName: "Mation, Auto",
    datetime: "2023-07-27T16:05:21.656958769Z",
    timezone: "America/Guatemala",
  },
  modifiedAction: {
    actionType: "PRINTED",
    userId: 744405,
    username: "auto@mation.com",
    displayName: "Mation, Auto",
    datetime: "2023-08-08T18:31:55.268421385Z",
    timezone: "America/Guatemala",
  },
  startDate: "2023-07-27T06:00:00Z",
  startDateDisplay: "07/27/2023",
  signatureRequests: {
    created: {
      signedStatus: OrderSignatureRequest.SignedStatusEnum.No,
    },
  },
  discipline: "Skilled Nurse",
  teamName: "Team MOO",
  teamId: 352,
  teamQbosId: 1102,
  history: [
    {
      actionType: "PRINTED",
      userId: 744405,
      username: "auto@mation.com",
      displayName: "Mation, Auto",
      datetime: "2023-08-08T18:31:55.268421385Z",
      timezone: "America/Guatemala",
      orderingProviderId: 0,
      orderingProviderDisplayName: "",
    },
    {
      actionType: "CREATED",
      userId: 744405,
      username: "auto@mation.com",
      displayName: "Mation, Auto",
      datetime: "2023-07-27T16:05:21.656958769Z",
      timezone: "America/Guatemala",
      orderingProviderId: 0,
      orderingProviderDisplayName: "",
    },
  ],
  orderingProviderId: 727180,
  orderingProviderDisplayName: "Beat, DoctorDre",
  approvalType: "verbal",
  readBackAndVerified: true,
  patientChartId: 203147,
  orderId: "10229",
  visits: 0,
  timeInterval: "DAY",
  duration: 0,
};

const testOrders: OrderResponse[] = [
  {
    orderType: "Medication",
    nameDescription: "Hydromet Syrup5- 1.5 mg / ml",
    orderingProviderDisplayName: "Matt Davis, MD",
    startDate: new Date().toISOString(),
    approvalType: Order.ApprovalTypeEnum.NoSignatureRequired,
    createdAction: {
      actionType: Action.ActionTypeEnum.Created,
      userId: 1234,
      datetime: new Date().toISOString(),
      timezone: "America/New_York",
    },
    dosageStrength: "20 MG",
    dosageFrequency: "1 tab PO every 6 hours as needed for nausea/vomiting",
    categories: new Set<string>(["Cardiovascular"]),
    hospicePays: true,
    administeredByOther: "Patient",
    timeInterval: Order.TimeIntervalEnum.Week,
    discontinuedAction: {
      actionType: Action.ActionTypeEnum.Discontinued,
      userId: 12344,
      datetime: new Date().toISOString(),
      timezone: "America/New_York",
      reason: "test",
      orderingProviderId: 1234,
      orderingProviderDisplayName: "Dr. Provider",
    },
    discontinueDate: new Date().toISOString(),
    PRNReasons: "-",
    dosageForm: "",
    dosageRoute: "",
    dosageDosage: "",
    levelOfCare: "",
    careLocationType: "",
    visits: 0,
    duration: 0,
    signatureRequests: {
      created: {
        signedStatus: OrderSignatureRequest.SignedStatusEnum.No,
      },
    },
    durationInterval: Order.TimeIntervalEnum.Week,
  },
  {
    orderType: "Medication",
    nameDescription: "Hydromet Syrup5- 1.5 mg / ml",
    orderingProviderDisplayName: "Matt Davis, MD",
    startDate: new Date().toISOString(),
    approvalType: Order.ApprovalTypeEnum.Written,
    createdAction: {
      actionType: Action.ActionTypeEnum.Created,
      userId: 1234,
      datetime: new Date().toISOString(),
      timezone: "America/New_York",
    },
    dosageStrength: "20 MG",
    dosageFrequency: "1 tab PO every 6 hours as needed for nausea/vomiting",
    categories: new Set<string>(["Cardiovascular"]),
    hospicePays: true,
    administeredByOther: "Patient",
    timeInterval: Order.TimeIntervalEnum.Week,
    discontinuedAction: {
      actionType: Action.ActionTypeEnum.Discontinued,
      userId: 12344,
      datetime: new Date().toISOString(),
      timezone: "America/New_York",
      reason: "test",
      orderingProviderId: 1234,
      orderingProviderDisplayName: "Dr. Provider",
    },
    discontinueDate: new Date().toISOString(),
    PRNReasons: "-",
    dosageForm: "",
    dosageRoute: "",
    dosageDosage: "",
    levelOfCare: "",
    careLocationType: "",
    visits: 0,
    duration: 0,
    signatureRequests: {
      created: {
        signedStatus: OrderSignatureRequest.SignedStatusEnum.No,
      },
    },
    durationInterval: Order.TimeIntervalEnum.Week,
  },
  {
    orderType: "DME",
    nameDescription: "Bedside Commode",
    orderingProviderDisplayName: "Matt Davis, MD",
    startDate: new Date().toISOString(),
    approvalType: Order.ApprovalTypeEnum.Written,
    createdAction: {
      actionType: Action.ActionTypeEnum.Created,
      userId: 1234,
      datetime: new Date().toISOString(),
      timezone: "America/New_York",
    },
    dosageStrength: "30 MG",
    dosageFrequency: "1 tab PO every 6 hours as needed for nausea/vomiting",
    categories: new Set<string>(["Cardiovascular"]),
    hospicePays: true,
    administeredByOther: "Patient",
    timeInterval: Order.TimeIntervalEnum.Week,
    discontinuedAction: {
      actionType: Action.ActionTypeEnum.Discontinued,
      userId: 12344,
      datetime: new Date().toISOString(),
      timezone: "America/New_York",
      reason: "test",
      orderingProviderId: 1234,
      orderingProviderDisplayName: "Dr. Provider",
    },
    discontinueDate: new Date().toISOString(),
    PRNReasons: "-",
    dosageForm: "",
    dosageRoute: "",
    dosageDosage: "",
    levelOfCare: "",
    careLocationType: "",
    visits: 0,
    duration: 0,
    signatureRequests: {
      created: {
        signedStatus: OrderSignatureRequest.SignedStatusEnum.No,
      },
    },
    durationInterval: Order.TimeIntervalEnum.Week,
  },
];

export function getMockSearch(request: OrderSearchRequest): OpenSearchResponse {
  const response: OpenSearchResponse = {
    hits: [],
  };
  response.hits.push(...testOrders);
  return response;
}

function getVFOrders(count: number): OrderResponse[] {
  const vfOrders: OrderResponse[] = [];
  for (const i of Array.from({ length: count ? count : 10 }, (_, i) => i)) {
    let vfOrder = { ...baseVFOrder };
    vfOrder.orderId = `${10000 + i}`;
    vfOrder.nameDescription = `Order ${10000 + i}`;
    const variant = i % 4;
    switch (variant) {
      case 0:
        vfOrder = {
          ...vfOrder,
          visits: 5,
          timeInterval: "WEEK",
          duration: 2,
          PRNQuantity: 1,
          PRNReasons: "PRNReasons",
          providerNotes: "providerNotes",
          discontinueDate: new Date().toISOString(),
        };
        break;
      case 1:
        vfOrder = {
          ...vfOrder,
          PRNQuantity: 1,
        };
        break;
      case 2:
        vfOrder = {
          ...vfOrder,
          visits: 5,
          timeInterval: "WEEK",
          duration: 2,
          providerNotes: "providerNotes",
          discontinueDate: new Date().toISOString(),
        };
        break;
      default:
        break;
    }
  }
  return vfOrders;
}



// WEBPACK FOOTER //
// ./src/providers/order-management-data-service/mock-search.ts